import { QRFC } from "./QRFC";
import { Globals } from "./Globals.js";

export class QMFARFC extends QRFC {
  constructor() {
    super();
  }

  InitMFARFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qmfa";
  }

  SetParams(org, username, mode, reset, confirmCode) {
    this.AddParameter("user", username);
    this.AddParameter("email", Globals._wsMgr.GetUserEmail());
    this.AddParameter("org", org);
    this.AddParameter("mode", mode);
    this.AddParameter("reset", reset);
    this.AddParameter("confirmCode", confirmCode);
  }

  DoTransactionComplete(response, callBackObj) {
    var qrCodeWrapper = response != "MFA Disabled" ? response : null;
    callBackObj.DisplayQRCode(qrCodeWrapper);
  }
}
